import React from "react";
import SpinWheelCard from "../../Pages/User/spinner-lottery/components/SpinWheelCard";
import { useWallet } from "../../../static/walletUtils";

const SpinWheel = ({ lotteryData, partner, partnerLogo }) => {
  const { account, connect } = useWallet();

  return (
    <SpinWheelCard
      lotteryData={lotteryData}
      partner={partner}
      partnerLogo={partnerLogo}
      account={account}
      onConnectWallet={connect}
    />
  );
};

export default SpinWheel;
